import { z } from "zod";

export const materialSchema = z.object({
  name: z
    .string()
    .min(1, "Ingresa un nombre de material.")
    .max(60, "El nombre debe tener un máximo de 60 caracteres.")
    .refine((val) => val.trim() === val, {
      message: "El nombre no puede tener espacios al inicio o al final.",
    }),
});

export type MaterialSchemaInfer = z.infer<typeof materialSchema>;
